import { FieldPutEvent } from '../event/field-put.event';
const fieldPutProjections = {
    [FieldPutEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            ...payload,
            tp2FieldName: payload.tp2FieldName ?? state.tp2FieldName ?? '',
            deleted: false,
        };
    },
};
export default fieldPutProjections;
//# sourceMappingURL=field-put.projection.js.map